import { useMutation } from '@apollo/client'
import clsx from 'clsx'
import { useContext } from 'react'
import { useForm } from 'react-hook-form'
import { LayoutContext } from '../../contexts/layout.context'
import {
  ADD_PARTNER_MUTATION,
  GET_ALL_PARTNERS_QUERY,
} from '../../graphql/partner.graphql'
import PartnerForm from '../partner/PartnerForm'

const AddPartnerModal = () => {
  const { handleSubmit, control } = useForm()
  const { closeModal } = useContext(LayoutContext)
  const [addPartnerMutation, addPartnerMutationResult] = useMutation(
    ADD_PARTNER_MUTATION,
    {
      refetchQueries: [
        {
          query: GET_ALL_PARTNERS_QUERY,
        },
      ],
      onCompleted: closeModal,
    },
  )

  const onSubmit = (values: { [x: string]: any }) => {
    addPartnerMutation({
      variables: {
        addPartnerInput: values,
      },
    })
  }

  const buttonClass = clsx('btn btn-primary', {
    'opacity-30': addPartnerMutationResult.loading,
  })

  return (
    <div>
      <h2 className="title">{"Ajout d'un partenaire"}</h2>

      <div className="mt-8">
        <div className="text-light">
          <form onSubmit={handleSubmit(onSubmit)}>
            <PartnerForm control={control as any} />

            <div className="flex justify-end mt-6">
              <button
                className={buttonClass}
                disabled={addPartnerMutationResult.loading}
              >
                {addPartnerMutationResult.loading
                  ? 'Enregistrement...'
                  : 'Enregistrer'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default AddPartnerModal
